var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailsGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 61,
    viewBox: "0 0 113 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 45.6681L28.5207 39.6053L50.9034 20.7143L56.9587 19.0239L76.2231 17.6518L94.0304 4.38088L111.541 1.18665L112 2.55874V60.1866H1V45.6681Z",
    fill: "url(#paint0_linear_0_1)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.819605 44.5561L19.214 41.7451C25.0313 40.8561 30.4586 38.2758 34.8205 34.3255L43.9402 26.0661C49.4574 21.0694 56.6351 18.3022 64.0786 18.3022L66.8108 18.3022C74.1919 18.3022 81.3139 15.5811 86.8146 10.6594L88.2598 9.36643C93.1221 5.0159 99.2702 2.36913 105.772 1.8273L112.313 1.28227",
    stroke: "#FF3F3F",
    strokeOpacity: 0.8,
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 57.4174,
    y1: 2.11235,
    x2: 57.4174,
    y2: 60.1866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3F3F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3F3F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailsGraph);
export default __webpack_public_path__ + "static/media/fails_graph.bbd02d94364a6bda06d73a411b12b910.svg";
export { ForwardRef as ReactComponent };